var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.guestUserPledgeEnabled
    ? _c(
        "base-view",
        { staticClass: "gfu-layout-wrapper gfu-signing-page js-main-content" },
        [
          _c("div", { staticClass: "_flexcol _gap-6 _fd-r--m" }, [
            _c(
              "div",
              { staticClass: "gfu-1of1 gfu-6of12--m" },
              [
                _c(
                  "div",
                  { staticClass: "gfu-content-head _mt-0" },
                  [
                    _c(
                      "base-title",
                      {
                        attrs: {
                          as: "h1",
                          level: "h1",
                          "data-qa": "page-title",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.Resources.Account.ContinueWithAnAccountHeader
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("external-login-actions", {
                  staticClass: "_mb-3",
                  attrs: { "return-url": _vm.checkoutUrl },
                }),
                _vm._v(" "),
                _c("login-form", {
                  staticClass: "gfu-box gfu-box--thick",
                  attrs: {
                    "return-url": _vm.checkoutUrl,
                    "create-account-url": _vm.createAccountUrl,
                    "data-qa": "login-form",
                  },
                  on: { success: _vm.onLoginSuccess, "sign-up": _vm.onSignUp },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "gfu-1of1 gfu-6of12--m" },
              [
                _c(
                  "div",
                  { staticClass: "gfu-content-head _mt-0" },
                  [
                    _c("base-title", { attrs: { as: "h2", level: "h1" } }, [
                      _vm._v(
                        _vm._s(_vm.Resources.Account.ContinueAsGuestHeader)
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("continue-as-guest-modal-form", {
                  attrs: { "action-url": _vm.checkoutUrl },
                }),
              ],
              1
            ),
          ]),
        ]
      )
    : _c("login-view", { attrs: { "return-url": _vm.checkoutUrl } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }